import React from 'react';

import ListPage from '../../sharedModules/listPage/ListPage';

const SpotQuotesListPage: React.FC = () => {
  const spotQuoteColumns = [
    {
      name: 'Customer',
      selector: 'customer_name',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Location',
      selector: 'job_location',
      sortable: true,
    },
    {
      name: 'Order',
      selector: 'work_order_number',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Completed',
      selector: 'completed_at_with_time',
      sortable: false,
      grow: 1,
    },
    {
      name: 'Flagged At',
      selector: 'spot_quote_flagged_at_with_time',
      sortable: false,
      grow: 1,
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={spotQuoteColumns}
      controller="spot_quotes/xoi_jobs"
      defaultSort="spot_quote_flagged_at desc"
      queryPlaceholder="Filter by customer name..."
      rowClickPath="spot_quotes"
      title="Spot Quotes"
    />
  );
};

export default SpotQuotesListPage;
